export default {
  // 模块名称
  reserveImplement: {
    // 按钮类
    button: {
      response: '应急响应',
      cancel:'取消',
      save:'确定'
    },
    // 文字标签类
    label: {
      position: '告警位置',
      manualReserve: '手动预案启动',
      reselect: '重新选择',
      alarmType: '告警类型',
      deviceSelect: '摄像机选择',
      reserveSelect: '预案选择'
    },
    // 提示类
    placeholder: {
      reserveDesc: '请输入预案描述',
    },
    // 消息类
    message: {
      noVideo: '暂无周边视频，您还没有选择区域',
      clickMap: '点击在地图中选择',
      noReserve: '您还没选择预案',
      noDesc: '请输入预案描述',
      choose: '点击选择'
    },
    // 标题类
    title: {
      alarmDesc: '告警描述',
      reserveDesc: '预案描述',
      manualReserve: '手动预案',
      reserveSteps: '预案流程预览',
      alarmReserve: '告警预案'
    }
  }
}
